"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.randomDependencies = void 0;
var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var randomDependencies = exports.randomDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createRandom: _factoriesAny.createRandom
};